// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf } from "@altostra/type-validations";
import { number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isRecommendedUserItem = objectOf({
  product_id: string,
  nst: string,
  sample_users: number,
  estimated_users_rate: number,
  estimated_users: number,
});

export const isRecommendedUserItems = objectOf({
  sample_users: number,
  sample_personalized_rate: number,
  sample_most_popular_rate: number,
  estimated_personalized_users: number,
  estimated_most_popular_users: number,
  items: arrayOf(isRecommendedUserItem),
});

export const isServingMetrics = objectOf({
  qualifying_activity_users: maybe(number),
  users_with_personalized_recommendations: maybe(number),
  generated_recommendation_users: maybe(number),
  generated_users_with_personalized_recommendations: maybe(number),
  generated_recommendation_personalization_rate: maybe(anyOf(number, nullValidation)),
  stored_recommendation_users: maybe(number),
  stored_users_with_personalized_recommendations: maybe(number),
  missing_user_doc_users: maybe(number),
  qualifying_activity_users_without_stored_recommendations: maybe(number),
  stored_recommendation_personalization_rate: maybe(anyOf(number, nullValidation)),
  qualifying_activity_since: maybe(number),
  qualifying_activity_until: maybe(number),
  total_users: maybe(number),
});

export const isEngagementRecommenderAnalytics = objectOf({
  coverage: maybe(number),
  precision: maybe(number),
  most_popular_items: arrayOf(string),
  trending_items: arrayOf(string),
  recommended_user_items: isRecommendedUserItems,
  serving_metrics: maybe(isServingMetrics),
  n_catalog_items: number,
});
